import { brandKitValidator } from "@redotech/redo-model/brand-kit";

import * as z from "zod";

export const updateBrandKit = {
  name: "updateBrandKit" as const,
  input: z.object({ brandKit: brandKitValidator }),
  output: z.object({ success: z.boolean() }),
};
